import { Component, OnInit, OnChanges, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { environment } from '../../../../environments/environment';
import {
  ProgramTypesGUID,
  EventWorkshop
} from '../../../../models/_enum-collections';
import {
  EventNoteModel,
  AddEventNoteRequestModel
} from '../../../../models/event-note.model';
import {
  EventRegistrationCustomerModel,
  EventRegistrationModel
} from '../../../../models/event-registration.model';
import { EventSearchFilterRequest } from '../../../../models/event-search-filter-request.model';
import { CommonSharedModule } from '../../../common/shared.module';
import { EventDashboardService } from '../../../services/event-dashboard.service';

@Component({
  selector: 'app-event-details',
  templateUrl: './event-details.component.html',
  styleUrls: ['./event-details.component.scss'],
  standalone: true,
  imports: [CommonSharedModule]
})
export class EventDetailsComponent implements OnInit, OnChanges {
  constructor(
    private formBuilder: FormBuilder,
    private eventDashboardService: EventDashboardService
  ) {}

  @Input() eventRegistrationId!: number;
  @Input() programTypeGUID!: string;
  @Input() eventCustomers!: EventRegistrationCustomerModel[];

  eventSearchFilterRequest!: EventSearchFilterRequest;
  event!: EventRegistrationModel;
  isOneToMany = true;
  formEditEvent!: FormGroup;
  notes!: EventNoteModel[];
  addNote!: AddEventNoteRequestModel;
  isMRPPProgram = false;
  formNotes!: FormGroup;

  async ngOnInit() {
    this.isMRPPProgram =
      this.programTypeGUID !== undefined &&
      this.programTypeGUID == ProgramTypesGUID.MRPP;
    this.onFormGroup();
    await this.loadEventInfo();
    this.loadInitialContent();
  }

  private loadInitialContent() {
    if (this.event) {
      this.formEditEvent.patchValue({
        eventRegistrationId: this.event.eventRegistrationId,
        eventRegistrationBatchId: this.event.eventRegistrationBatchId,
        eventStatus: this.event.eventStatusName,
        eventName: this.event.eventName,
        partnerName: this.event.partnerOrgName,
        facilitatorName: this.event.facilitatorName,
        facilitatorCountryName: this.event.facilitatorCountryName,
        requestDate: this.event.requestDate,
        taskOwner: this.event.taskOwner,
        targetProduct: this.event.eventTargetProductName,
        isMultiTargetProductSupported: this.event.isMultiTargetProductSupported,
        pmonextStepName: this.event.pmonextStepName,
        customerName:
          Array.isArray(this.eventCustomers) && this.eventCustomers.length > 0
            ? this.eventCustomers[0].customerName
            : '',
        tpName: this.event.tpName
      });

      this.getNotesList(this.eventRegistrationId);
    }
  }

  onFormGroup(): void {
    this.formEditEvent = this.formBuilder.group({
      eventRegistrationId: [''],
      eventRegistrationBatchId: [''],
      eventStatus: [''],
      eventName: [''],
      partnerName: [''],
      facilitatorName: [''],
      facilitatorCountryName: [''],
      requestDate: [''],
      taskOwner: [''],
      targetProduct: [''],
      customerName: [''],
      pmonextStepName: [''],
      tpName: ['']
    });

    this.formNotes = this.formBuilder.group({
      notes: ['']
    });
  }

  getNotesList(eventRegistrationId: number): void {
    this.eventDashboardService
      .getEventNotes(eventRegistrationId)
      .subscribe(notes => {
        this.notes = notes;
      });
  }

  get EventWorkshop(): typeof EventWorkshop {
    return EventWorkshop;
  }

  get release(): string {
    return environment.isProdEnvironment ? 'Prod' : 'Dev';
  }

  onSubmitNotes() {
    this.addNote = {
      eventRegistrationId: this.event.eventRegistrationId,
      notes: this.formNotes.controls['notes'].value
    };

    this.eventDashboardService
      .addEventNote(this.addNote)
      .subscribe(messageResponse => {
        if (messageResponse.success) {
          this.getNotesList(this.eventRegistrationId);
        }
      });

    this.formNotes.controls['notes'].setValue('');
  }

  refreshNotes(): void {
    this.getNotesList(this.event.eventRegistrationId);
  }

  async refreshEvent() {
    await this.loadEventInfo();
    this.loadInitialContent();
  }

  async loadEventInfo() {
    const eventRegistration = await this.eventDashboardService
      .getEventRegistration(this.eventRegistrationId)
      .toPromise();
    if (eventRegistration) {
      this.event = eventRegistration;
    }
    this.isOneToMany = eventRegistration?.isOneToMany || false;
  }

  ngOnChanges(): void {
    this.loadInitialContent();
  }
}
